/* eslint-disable max-len */

export default {
  blocks: [
    {
      key: 'cjvg0',
      text: 'blabla',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '62ujq',
      text: ' ',
      type: 'atomic',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [
        {
          offset: 0,
          length: 1,
          key: 0,
        },
      ],
      data: {},
    },
    {
      key: '4ig3u',
      text: '',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'd1fo2',
      text: '',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'agkmb',
      text: ' ',
      type: 'atomic',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [
        {
          offset: 0,
          length: 1,
          key: 1,
        },
      ],
      data: {},
    },
    {
      key: '56pj9',
      text: '',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
  ],
  entityMap: {
    '0': {
      type: 'wix-draft-plugin-image',
      mutability: 'IMMUTABLE',
      data: {
        config: {
          alignment: 'center',
          size: 'content',
          showTitle: true,
          showDescription: true,
          link: null,
          anchor: 'cjvg0',
        },
        src: {
          id: '9d652929eb67d0ae370494dcb2709871',
          original_file_name: '8bb438_18a34be7a3834da88a55e30c4dae3e96.jpg',
          file_name: '8bb438_18a34be7a3834da88a55e30c4dae3e96.jpg',
          width: 1621,
          height: 1081,
        },
      },
    },
    '1': {
      type: 'wix-draft-plugin-image',
      mutability: 'IMMUTABLE',
      data: {
        config: {
          alignment: 'center',
          size: 'content',
          showTitle: true,
          showDescription: true,
          link: null,
          anchor: 'cjvg0',
        },
        src: {
          id: '5fb9385c24ba5972991a2da94fe5b550',
          original_file_name: '8bb438_37f441d6939f4c1eb8e335b231afb7b9.jpg',
          file_name: '8bb438_37f441d6939f4c1eb8e335b231afb7b9.jpg',
          width: 5600,
          height: 3737,
        },
      },
    },
  },
  VERSION: '7.12.3',
};
